// local
import {
  SET_IS_MODULE_LOADED,
  SecCallbackActions,
  SetInputValidated,
  SET_INPUT_SEC_SHORT,
  SET_FORM_LOADING_SEC_SHORT,
  SetFormLoading,
  SET_PHONE_INPUT_SEC_SHORT,
  SetPhoneInputValidated,
  SET_FORM_SUCCESS_SEC_SHORT,
  SetFormSuccess,
  SetGeneralErrorMessage,
  SET_CHECKBOX_SEC_SHORT,
  SetCheckboxValidated,
  SET_GENERAL_ERROR_SEC_SHORT,
  RESET_FORM_SEC_SHORT,
  SetCampaign,
  SET_CAMPAIGN_SEC_SHORT,
} from './actions';

export type SecShortData = {
  isModuleLoaded: boolean;
  isLoading: boolean,
  isSuccess: boolean,
  generalError: {
    message?: string,
  },
  webstoreUrl: {
    value: string,
    error: string,
  },
  recaptcha: {
    value: string,
    error: string,
  },
  name: {
    value: string,
    error: string,
  },
  phoneNumber: {
    countryCode: string,
    number: string,
    error: string,
  },
  email: {
    value: string,
    error: string,
  },
  agreeToTermsAndConditions: {
    value: {[key: string]: boolean},
    error: string,
  },
  campaign: {
    name: string;
    source: string;
    medium: string;
  }
};

export const initialState: SecShortData = {
  isModuleLoaded: false,
  isLoading: false,
  isSuccess: false,
  generalError: {
    message: '',
  },
  webstoreUrl: {
    value: '',
    error: '',
  },
  recaptcha: {
    value: '',
    error: '',
  },
  name: {
    value: '',
    error: '',
  },
  phoneNumber: {
    countryCode: '+971',
    number: '',
    error: '',
  },
  email: {
    value: '',
    error: '',
  },
  agreeToTermsAndConditions: {
    value: {
      agreed: true,
    },
    error: '',
  },
  campaign: {
    name: '',
    source: '',
    medium: '',
  },
};

const secCallbackReducer = (
  state: SecShortData = initialState,
  action: SecCallbackActions,
): SecShortData => {
  switch (action.type) {
    case SET_IS_MODULE_LOADED:
      return {
        ...state,
        isModuleLoaded: true,
      };
    case SET_INPUT_SEC_SHORT:
      return {
        ...state,
        ...(action as SetInputValidated).payload,
      };
    case SET_PHONE_INPUT_SEC_SHORT:
      return {
        ...state,
        ...(action as SetPhoneInputValidated).payload,
      };
    case SET_CHECKBOX_SEC_SHORT:
      console.log('SET_CHECKBOX_SEC_SHORT action:', action, state); // eslint-disable-line
      return {
        ...state,
        agreeToTermsAndConditions: {
          ...(state.agreeToTermsAndConditions || {}),
          value: {
            agreed: Boolean((action as SetCheckboxValidated).payload.isChecked),
          },
        },
      };
    case SET_CAMPAIGN_SEC_SHORT: {
      return {
        ...state,
        campaign: (action as SetCampaign).payload,
      };
    }
    case SET_FORM_LOADING_SEC_SHORT: {
      return {
        ...state,
        isLoading: (action as SetFormLoading).payload.isLoading,
      };
    }
    case SET_FORM_SUCCESS_SEC_SHORT: {
      return {
        ...state,
        isSuccess: (action as SetFormSuccess).payload.isSuccess,
      };
    }
    case SET_GENERAL_ERROR_SEC_SHORT: {
      return {
        ...state,
        generalError: {
          message: (action as SetGeneralErrorMessage).payload,
        },
      };
    }
    case RESET_FORM_SEC_SHORT: {
      return initialState;
    }
    default:
      return state;
  }
};

export default secCallbackReducer;
